import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiSignatureDuotone, PiPencilSimpleSlashBold } from 'react-icons/pi';
import { IColorProp } from 'types/components/components.interface';
import { SIGNATURE_TYPE } from 'services/advance/types';

export interface ILabeledStatusProps {
  status: SIGNATURE_TYPE;
}

interface ILabeledStatusParams extends IColorProp {
  status: SIGNATURE_TYPE;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: SIGNATURE_TYPE.false,
    color: 'red',
    icon: <PiPencilSimpleSlashBold />,
  },
  {
    status: SIGNATURE_TYPE.true ,
    color: 'blue',
    icon: <PiSignatureDuotone />,
  },
];

const LabelSignatureStatus = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}
    >
      {labeledParams.icon}{' '}
      {t(`enum.LABEL_ADVANCE.${labeledParams.status}`)}
    </Label>
  );
};

export default LabelSignatureStatus;
